import { safeSanitize } from '../../utils/safe_sanitize';

angular.module("LeasePilot").controller("ManagePartnersController", [
  "$scope",
  "$rootScope",
  "$mdDialog",
  "PartnersService",
  function($scope, $rootScope, $mdDialog, PartnersService) {
    // Helper function to escape Angular expressions and HTML to prevent XSS
    function escapeForTemplate(text) {
      if (!text || typeof text !== 'string') return text || '';
      // Remove Angular interpolation markers first to prevent expression evaluation
      let cleanText = text.replace(/{{.*?}}/g, '');
      // Strip all HTML tags and attributes to prevent XSS
      cleanText = safeSanitize(cleanText, {
        allowedTags: [],
        allowedAttributes: [],
      });
      // Additional escape for template literal context (HTML attributes)
      return cleanText
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;');
    }

    $scope.init = async function() {
      window.track.event(new LoadPartnerManagementEvent());
      
      $scope.isProcessing = false;
      
      const availableBuildingIds = new Set($scope.buildings.map(building => building.id));

      $scope.partners = Object.values($rootScope.partners);
      
      $scope.partners.forEach(partner => {
        partner.buildings = partner.buildings.filter(buildingId => availableBuildingIds.has(buildingId));
      });
    };

    $scope.showAssignBuildingsDialog = function(partner) {
      window.track.event(new LoadAssignBuildingsToPartnerEvent({
        id: partner.id,
      }));
      $mdDialog.show({
        template: `<md-dialog><assign-buildings-modal partner-id="${escapeForTemplate(String(partner.id))}" partner-name="${escapeForTemplate(partner.name)}" buildings="${escapeForTemplate(JSON.stringify(partner.buildings))}" /></md-dialog>`,
        parent: angular.element(document.body),
        fullscreen: false
      });
    };
  }
]);
